import React, { Component } from "react";
import {LanguageContext} from "./LanguageContext"
import LocalizedStrings from 'react-localization';

import './App.scss';

let strings = new LocalizedStrings({
    en:{
        className:"booktitleEnglish",
        title:"infinity texts",
        fullscreen: "view in fullscreen",
        exitFullscreen: "exit fullscreen"
    },
    de:{
        className:"booktitleGerman",
        title:"unendlichkeitstexte",
        fullscreen: "zeige als vollbild",
        exitFullscreen: "verlasse vollbild"
    }
});

class BookTitle extends Component {
    componentDidMount() {
        this.props.onchangePoemInfo({title:"", description:""})
    }

    render() {
        strings.setLanguage(this.context.language)

        return (
            <div className="centered">
                <h1 className={strings.className}>{strings.title}</h1>
                <h1 className="infinitysign">∞</h1>
                {this.props.fullscreenEnabled &&
                    <>
                        <button className="controlButton" onClick={this.props.toggleFullscreen}>{this.props.isFullscreen ? strings.exitFullscreen : strings.fullscreen}</button><br />
                        <br />
                    </>
                }
                <button className={"controlButton"+(this.context.language === "en" ? " selectedButton" : " deselectedButton")} onClick={() => this.props.onSetLanguage("en")}>english</button>
                <button className={"controlButton"+(this.context.language === "de" ? " selectedButton" : " deselectedButton")} onClick={() => this.props.onSetLanguage("de")}>deutsch</button>
            </div>
        );
    }
}
BookTitle.contextType = LanguageContext

export default BookTitle;
